module.exports = __webpack_public_path__ + "img/dateSingedEle.45bf0c09.svg";